export function normalizeProductName(name: string): string {
    return name
        .replace(/\b(CPF|CNPJ|PF|PJ)\b/gi, '')  // remove CPF / CNPJ
        .replace(/\s+/g, ' ')             // compacta múltiplos espaços
        .trim();
}